import { Component, OnInit } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { ApiService } from '../../shared/api.service';
import { EventSendeurService } from '../../shared/event-sendeur.service';
import { EditFormationComponent } from './edit-formation/edit-formation.component';
import { LocalDataSource } from 'ng2-smart-table';
import { Router } from '@angular/router';
import { plainToClass } from 'class-transformer';
import { Categorie } from '../../shared/data/categorie';
import swal from 'sweetalert2';
import { Formation } from '../../shared/data/formation';
import { PublishRenderComponent } from '../projet/publish-render.component';

@Component({
  selector: 'ngx-formation',
  templateUrl: './formation.component.html',
  styleUrls: ['./formation.component.scss']
})
export class FormationComponent implements OnInit {

  categories:any =[];
  
  source: LocalDataSource =  new LocalDataSource();
  settings = {
 
     hideSubHeader: false,
     mode: 'external',
     actions: {
      columnTitle: '',
      position: 'left',
      add: true,
      edit: true,
      delete: true,
     },
     add: {
      addButtonContent: '<i class="nb-plus"></i>',
      confirmCreate: false,
    },
     edit: {
       editButtonContent: '<i class="nb-edit"></i>',
       saveButtonContent: '<i class="nb-checkmark"></i>',
       cancelButtonContent: '<i class="nb-close"></i>',
       confirmSave:false
     },
     delete: {
       deleteButtonContent: '<i class="nb-trash"></i>',
       confirmDelete: true,
     },
   columns: {
     id: {
       title: 'ID',
       type: 'number',
       filter: false,
     },
     chemin: {
       title: 'Titre',
       type: 'string',
     },
     /* labelCycle: {
      title: 'Cycle',
      type: 'string',
    }, */
    /* label_categorie: {
      title: 'Categorie',
      type: 'string',
    }, */
    /* labelAdmission: {
      title: 'Admission',
      type: 'string',
    }, */
   /*  is_publish: {
      title: '',
      type: 'custom',
      renderComponent: PublishRenderComponent, // ne pas oublier de déclarer dans le module et d'ajouter dans l'entré entryComponents
      filter: false,
    }, */
  
   },
   pager : {
                 perPage :10
   },
  
  };

 constructor(private router:Router,private dialogService: NbDialogService,private apiService:ApiService,private sendeurService:EventSendeurService,private toastr:NbToastrService) { }
 
 ngOnInit() {
    this.getFormations();


    this.sendeurService.formationEvent.subscribe(data =>{
      this.getFormations();
    })

  }

 

  getFormations(){

    this.apiService.getAllformationProvider('').subscribe(data =>{
     

      this.source.load( plainToClass( Formation, data) );
      /* const tmps = data as any[];   
      this.categories = tmps.map(tmp => {
        return {
        
          nom: tmp.nom,   
          id:tmp.id,
          description:tmp.description
        };
      
      }); */

    })

  }

  
  

  onDelete(event){
    // this.dialogService.open(DeleteCategoryComponent,{ context:{id:$event.data.id}});

    // this.dialogService.open(DeletePageComponent,{context:{id:$event.data.id}});
    const formation = plainToClass( Formation,  event.data as object);
    
    swal({
      title: 'Suppression formation',
      text: 'Voulez - vous vraiment supprimer ' + formation.titre + ' ? Vous ne pourrez plus annuler cet opération',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Confirmer',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: () => {

        // this.dialogIsNotShow = true;

        return this.apiService.deleteFormationProvider(formation.id).subscribe(data =>{

          // console.log(data);
          this.source.remove(event.data);
          this.toastr.success("Suppréssion réussie", formation.titre);

        },(err) =>{

          this.toastr.danger("Echec de suppréssion ");
          if(err.error.code ===401){
            localStorage.clear();
            window.location.reload();
            let link2 = ['/login'];
            this.router.navigate(link2);
          }

          if(err.error.code ===500){

            this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");

          }

        })

      },
    }).then((result) => {

      if (result.value) {


        /* this.toastr.success("Suppréssion réussie", formation.titre); */

      }

      // this.dialogIsNotShow = false;

    });


  }

  
  select($event){
    this.dialogService.open(EditFormationComponent,{context:{id:$event.data.id}});
  }

  onCreate(event){
    this.createFormation();
  }

  createFormation(){
    this.dialogService.open(EditFormationComponent,{context:{id:0}});
  }

  

}
